import { createContext, useContext } from 'react'
import { type MenuOption } from '@opallabs/concepts'
import { DataProps, UnwrappedValue } from '../types'

export type DataContextValue = Omit<DataProps<unknown>, 'onChange'> & {
  onChange: (item: null) => void
}

const DataContext = createContext<DataContextValue | undefined>(undefined)
DataContext.displayName = 'Lapidary: DataContext ← SingleSelect'

export const DataProvider = ({
  children,
  initialSelection,
  onChange,
  options,
  selectedOption,
}: DataContextValue & { children: React.ReactNode }) => {
  return (
    <DataContext.Provider
      value={{
        initialSelection,
        onChange,
        options,
        selectedOption,
      }}
    >
      {children}
    </DataContext.Provider>
  )
}
DataProvider.displayName = 'Lapidary: DataProvider ← SingleSelect'

export const useSingleSelectData = <
  Option extends MenuOption<OptionValue>,
  OptionValue extends string | number | boolean = UnwrappedValue<Option>,
>() => {
  const context = useContext(DataContext) as DataProps<Option>

  if (!context) {
    throw new Error(
      'useSingleSelectData must be used within SingleSelectContext.InitialDataProvider.'
    )
  }

  return context
}
